class Palette
{
    constructor(width, height, colors)
    {
        this.width = width;
        this.height = height;
        this.colors = colors;
    }

    /**
     * Color lookup
     *
     * @param {Number} x    x-coordinate  0...1
     * @param {Number} y    x-coordinate  0...1
     * @return {string} color
     */
    lookup(x,y)
    {
        const { width, height, colors} = this;

        const xi = ((width - 1) * x)|0;
        const yi = ((height - 1) * y)|0;

        //console.log("lookupGrassStyle", n, n2, xi, yi);

        return colors[width * yi + xi];
    }
}



export default function loadGrassPalette(img)
{
    const canvas = document.createElement("canvas");
    const width = img.width;
    const height = img.height;
    canvas.width = width;
    canvas.height = height;
    canvas.className="offscreen";

    document.body.appendChild(canvas);
    const ctx = canvas.getContext("2d");
    ctx.drawImage(img, 0 , 0);

    const imageData = ctx.getImageData(0, 0, width, height);

    document.body.removeChild(canvas);


    const colors = new Array(width * height);

    const lineWidth = imageData.width * 4;
    const data = imageData.data;

    let index = 0;
    for(let y = 0; y < height; y++)
    {
        for(let x = 0; x < width; x++)
        {
            const off = y * lineWidth + x * 4;
            colors[index++] = "rgba(" + data[off] + ","  + data[off + 1] + ","  + data[off + 2] + ", 0.99)"
        }
    }

    return new Palette(
        width,
        height,
        colors
    );
}
